module.exports = __webpack_public_path__ + "img/facebook.f88081b9.svg";